module.exports = __webpack_public_path__ + "static/img/MY.a23b05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/MY.png
// module id = mnnS
// module chunks = 2